import React, { useState, useEffect } from 'react'
import ScheduleIcon from '@material-ui/icons/Schedule'

import MomentUtils from '@date-io/moment'
import {
  makeStyles,
  createMuiTheme,
  ThemeProvider
} from '@material-ui/core/styles'
import { red } from '@material-ui/core/colors'
import {
  KeyboardTimePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers'

const useStyles = makeStyles({
  timePickerStyle: {
    width: '100%'
  },
  timepickerIcons: {
    '&& .MuiIconButton-root': {
      padding: '2px'
    }
  }
})
const theme = createMuiTheme({
  palette: {
    primary: red
  }
})
const CustomMuiTimePicker = props => {
  const classes = useStyles()
  const [, setSelectedTime] = useState()
  const [, stateUpdate] = useState('')

  useEffect(() => {
    props.linkStateUpdater(stateUpdate)
  }, [])
  const handleTimeChange = (date, ding) => {
    props.timeChange(date)
    setSelectedTime(date)
  }
  return (
    <ThemeProvider theme={theme}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <KeyboardTimePicker
          views={['hours', 'minutes', 'seconds']}
          format='hh:mm:ss A'
          className={classes.timePickerStyle}
          value={props.getSelectedTime()}
          ampm={props.ampm}
          onChange={date => handleTimeChange(date)}
          onAccept={date => handleTimeChange(date)}
          variant='inline'
          autoOk
          InputAdornmentProps={{
            position: 'end',
            classes: { root: classes.timepickerIcons }
          }}
          keyboardIcon={<ScheduleIcon />}
        />
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  )
}
export default CustomMuiTimePicker
